import React, { useState } from 'react'
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  AppBar,
  Toolbar,
  IconButton,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Paper
} from '@mui/material'
import {
  ArrowBack as ArrowBackIcon,
  Close as CloseIcon,
  NavigateNext as NavigateNextIcon
} from '@mui/icons-material'

const EducationGhostTutorial = ({ onBack, onHighlightCard, onClose }) => {
  const [currentStep, setCurrentStep] = useState(0)

  // İlk render'da ilk adımın kartını vurgula
  React.useEffect(() => {
    if (onHighlightCard && tutorialSteps[0].highlight) {
      onHighlightCard(tutorialSteps[0].highlight)
    }
  }, [onHighlightCard])

  const tutorialSteps = [
    {
      message: "Evet Evet Tekrar Ben!👻\n\n Bu kez sana eğitim panelini tanıtacağım. Hazır mısın?",
      highlight: null
    },
    {
      message: "Bu kartlar ile İngilizce öğrenme yolculuğuna başlayabilirsin.",
      highlight: null
    },
    {
      message: "📖 Okuma Kartı\nİngilizce metinleri okuyabilir, kelime bilgini geliştirebilirsin.",
      highlight: 'reading'
    },
    {
      message: "🎮 Oyun Kartı\nEğlenceli oyunlar ile İngilizce öğren , pratik yap. Ayrıca puanlarınla leaderboard da zirveye tırmanmaya ne dersin?",
      highlight: 'game'
    },
    {
      message: "🎧 Dinleme Kartı\nGünlük hayatta en çok ihtiyacın olan ingilizce cümleleri dinleyerek telaffuzunu geliştir.",
      highlight: 'listening'
    },
    {
      message: "📝 Kelime Listesi\nÖğrendiğin kelimeleri burada görebilir , çalışılanlara ekleyebilirsin.Ayrıca bildirim olarak da günlük hatırlatma alabilirsin",
      highlight: 'word-list'
    },
    {
      message: "Tanıştığıma çok çok memnun oldum.Beni her zaman ziyaret edebilirsin görselime tıklaman yeterli. Haydi! Başarı yolunda beraber engelleri ghostlayalım...",
      highlight: null
    }
  ]

  const handleNext = () => {
    if (currentStep < tutorialSteps.length - 1) {
      setCurrentStep(currentStep + 1)
      // Kart vurgulamasını güncelle
      if (onHighlightCard) {
        onHighlightCard(tutorialSteps[currentStep + 1].highlight)
      }
    } else {
      handleClose()
    }
  }

  const handleSkip = () => {
    handleClose()
  }

  const handleClose = () => {
    onClose()
  }

  return (
    <>
      {/* Tutorial Dialog */}
      <Dialog
        open={true}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            backgroundColor: '#f8f9fa',
            position: 'relative',
            zIndex: 1300
          }
        }}
      >
        <DialogContent sx={{ p: 3, textAlign: 'center' }}>
          <Box sx={{ mb: 2 }}>
            <Typography variant="h4" sx={{ mb: 1 }}>
              👻
            </Typography>
          </Box>
          
          <Typography 
            variant="body1" 
            sx={{ 
              mb: 3, 
              whiteSpace: 'pre-line',
              lineHeight: 1.6,
              fontSize: '16px',
              color: '#333'
            }}
          >
            {tutorialSteps[currentStep].message}
          </Typography>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Button
              onClick={handleSkip}
              sx={{ 
                color: '#666',
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: 'transparent',
                  textDecoration: 'underline'
                }
              }}
            >
              Atlayın
            </Button>
            
            <Button
              variant="contained"
              onClick={handleNext}
              endIcon={<NavigateNextIcon />}
              sx={{
                backgroundColor: '#1976d2',
                '&:hover': {
                  backgroundColor: '#1565c0'
                }
              }}
            >
              {currentStep < tutorialSteps.length - 1 ? 'İleri' : 'Bitir'}
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default EducationGhostTutorial
